import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import axios from '../../axios';
import config from '../../config';
import './Blog.css';

const BlogAdmin = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [adminLoggedIn, setAdminLoggedIn] = useState(false);
  const history = useHistory();
  const backend_url = config.backend_url.replace(/\/$/, '');

  useEffect(() => {
    // Check if admin is logged in
    const checkAdmin = async () => {
      // First check session storage
      const isLoggedIn = sessionStorage.getItem('blog_admin_logged_in') === 'true';
      
      if (isLoggedIn) {
        setAdminLoggedIn(true);
        fetchPosts();
      } else {
        // Verify with server
        try {
          const response = await axios.get(
            `${backend_url}/blog/admin/check`,
            { withCredentials: true }
          );
          
          if (response.data.is_admin) {
            setAdminLoggedIn(true);
            sessionStorage.setItem('blog_admin_logged_in', 'true');
            fetchPosts();
          } else {
            // Redirect to login
            history.push('/adminblog');
          }
        } catch (err) {
          console.error('Error checking admin status:', err);
          // Redirect to login
          history.push('/adminblog');
        }
      }
    };
    
    checkAdmin();
  }, [backend_url, history]);

  const fetchPosts = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${backend_url}/blog/posts?admin=true`,
        { withCredentials: true }
      );
      
      if (response.data.success) {
        setPosts(response.data.posts);
      } else {
        setError('Failed to fetch blog posts');
      }
    } catch (err) {
      console.error('Error fetching blog posts:', err);
      setError('Failed to fetch blog posts. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await axios.post(
        `${backend_url}/blog/admin/logout`,
        {},
        { withCredentials: true }
      );
      
      sessionStorage.removeItem('blog_admin_logged_in');
      history.push('/adminblog');
    } catch (err) {
      console.error('Error logging out:', err);
    }
  };

  const handleAddPost = () => {
    history.push('/adminblog/post/new');
  };

  const handleEditPost = (postId) => {
    history.push(`/adminblog/post/edit/${postId}`);
  };

  const handleDeletePost = async (postId) => {
    if (!window.confirm('Är du säker på att du vill ta bort detta inlägg?')) {
      return;
    }
    
    try {
      const response = await axios.delete(
        `${backend_url}/blog/posts/${postId}`,
        { withCredentials: true }
      );
      
      if (response.data.success) {
        // Remove post from state
        setPosts(posts.filter(post => post.id !== postId));
      } else {
        alert('Failed to delete blog post');
      }
    } catch (err) {
      console.error('Error deleting blog post:', err);
      alert('Error deleting blog post');
    }
  };

  // Format date to readable format
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('sv-SE', options);
  };

  if (!adminLoggedIn) {
    return <div>Verifying admin status...</div>;
  }

  if (loading) {
    return (
      <div className="blog-admin-container">
        <h1>Admin Dashboard</h1>
        <p>Laddar inlägg...</p>
      </div>
    );
  }

  return (
    <div className="blog-admin-container">
      <div className="blog-admin-header">
        <h1>Blog Admin Dashboard</h1>
        <div>
          <button className="blog-add-button" onClick={handleAddPost}>
            Nytt inlägg
          </button>
          <button className="blog-back-link" onClick={handleLogout} style={{ marginLeft: '10px' }}>
            Logga ut
          </button>
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}

      {posts.length === 0 ? (
        <p>Inga inlägg än. Klicka på "Nytt inlägg" för att skapa det första inlägget.</p>
      ) : (
        <table className="blog-table">
          <thead>
            <tr>
              <th>Titel</th>
              <th>Författare</th>
              <th>Publicerad</th>
              <th>Datum</th>
              <th>Åtgärder</th>
            </tr>
          </thead>
          <tbody>
            {posts.map((post) => (
              <tr key={post.id}>
                <td>{post.title}</td>
                <td>{post.author}</td>
                <td>{post.is_published ? 'Ja' : 'Nej'}</td>
                <td>{formatDate(post.created_at)}</td>
                <td>
                  <div className="blog-action-buttons">
                    <button 
                      className="blog-edit-button"
                      onClick={() => handleEditPost(post.id)}
                    >
                      Redigera
                    </button>
                    <button 
                      className="blog-delete-button"
                      onClick={() => handleDeletePost(post.id)}
                    >
                      Ta bort
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default BlogAdmin; 